module.exports = __webpack_public_path__ + "img/179967.26b23d79.png";